import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
const API_BASE = import.meta.env.VITE_API_BASE_URL || '/api';
export const useApi = () => {
    const { token, logout } = useAuth();
    const request = useCallback(async (path, method, body) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const response = await fetch(`${API_BASE}${path}`, {
            method,
            headers,
            body: body ? JSON.stringify(body) : undefined
        });
        if (response.status === 401) {
            logout();
            throw new Error('Session expired');
        }
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || 'Request failed');
        }
        if (response.status === 204) {
            return {};
        }
        return (await response.json());
    }, [token, logout]);
    return {
        get: (path) => request(path, 'GET'),
        post: (path, body) => request(path, 'POST', body),
        put: (path, body) => request(path, 'PUT', body),
        del: (path) => request(path, 'DELETE')
    };
};
